<template>

  <t-page>

    <t-page-general :current-page="currentPage" :user-auth="userAuth">

      <div class="grid-menu grid-menu-2col">

        <div class="no-gutters row">

          <div class="col-sm-4">
            <t-button class="btn-icon-vertical btn-square btn-transition btn btn-outline-primary"
                      :hasAccess="relationAccessSubValidation('sub-general-setting-param')"
                      to="place-setting-param">
              <i class="lnr-list btn-icon-wrapper btn-icon-lg mb-3"> </i>
              Parâmetros
            </t-button>
          </div>


          <div class="col-sm-4">
            <t-button class="btn-icon-vertical btn-square btn-transition btn btn-outline-primary"
                      :hasAccess="relationAccessPageGeneral('checklist-type-item')"
                      to="checklist-type-item">
              <i class="lnr-eye btn-icon-wrapper btn-icon-lg mb-3"> </i>
              Tipos de Itens
            </t-button>
          </div>

          <div class="col-sm-4">
            <t-button class="btn-icon-vertical btn-square btn-transition btn btn-outline-primary"
                      :hasAccess="relationAccessPageGeneral('place-type-enterprise')"
                      to="place-type-enterprise">
              <i class="lnr-apartment btn-icon-wrapper btn-icon-lg mb-3"> </i>
              Perfis de Empreendimentos
            </t-button>
          </div>




        </div>

        <div class="no-gutters row">


          <div class="col-sm-4">
            <t-button class="btn-icon-vertical btn-square btn-transition btn btn-outline-primary"
                      :hasAccess="relationAccessPageGeneral('place-type-environment')"
                      to="place-type-environment">
              <i class="lnr-store btn-icon-wrapper btn-icon-lg mb-3"> </i>
              Modelos de Ambientes
            </t-button>
          </div>


          <div class="col-sm-4">
            <t-button class="btn-icon-vertical btn-square btn-transition btn btn-outline-primary"
                      :hasAccess="relationAccessPageGeneral('place-type-spot-folder')"
                      to="place-type-spot-folder">
              <i class="lnr-map btn-icon-wrapper btn-icon-lg mb-3"> </i>
              Tipos de Pavimentos
            </t-button>
          </div>





          <div class="col-sm-4">
            <t-button class="btn-icon-vertical btn-square btn-transition btn btn-outline-primary"
                      :hasAccess="relationAccessPageGeneral('place-spot-specification')"
                      to="place-spot-specification">
              <i class="lnr-spell-check btn-icon-wrapper btn-icon-lg mb-3"> </i>
              Especificações
            </t-button>
          </div>




        </div>


        <div class="no-gutters row">



          <div class="col-sm-4">
            <t-button class="btn-icon-vertical btn-square btn-transition btn btn-outline-primary"
                      :hasAccess="relationAccessPageGeneral('place-spot-detail')"
                      to="place-spot-detail">
              <i class="lnr-select btn-icon-wrapper btn-icon-lg mb-3"> </i>
              Detalhes
            </t-button>
          </div>

          <div class="col-sm-4">
            <t-button class="btn-icon-vertical btn-square btn-transition btn btn-outline-primary"
                      :hasAccess="relationAccessPageGeneral('place-type-spot-detail')"
                      to="place-type-spot-detail">
              <i class="lnr-page-break btn-icon-wrapper btn-icon-lg mb-3"> </i>
              Agrupamento Detalhes
            </t-button>
          </div>


        </div>


      </div>

    </t-page-general>

  </t-page>

</template>
<script>
import pageDefaultMixin from "@/mixins/page/pageDefaultMixin"

export default {
  mixins: [pageDefaultMixin],
  name: 'EmployeeSettings',
  data() {
    return {}
  },
  methods: {

    mountedPrepare() {


    },
    async mountedContinued() {

    }
    //--------------------------------------------------------------------------------------
    //Início de métodos personalizados desta tela


    //--------------------------------------------------------------------------------------
  },
  async mounted() {

    this.mountedPrepare()

    await this.mountedDefault()

    await this.mountedContinued()

  },
  computed: {},

}
</script>
